
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { actions } from "../../actions/actionsWrapper";
import { eDotDanhGiaActionTypeIds, IDotDanhGiaActions } from "../../action-types/danh-gia/IDotDanhGiaActionType";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { dotDanhGiaApi } from "../../../api/danh-gia/dotDanhGiaApi";
import { IDotDanhGiaSelectRequest } from "../../../models/request/danh-gia/IDotDanhGiaSelectRequest";
import { IDotDanhGia } from "../../../models/response/danh-gia/IDotDanhGia";
const mainAction = actions.danhGia.dotDanhGiaActions;
export function* dotDanhGiaSaga(): any {
    yield takeLatest(eDotDanhGiaActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eDotDanhGiaActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eDotDanhGiaActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IDotDanhGiaActions): any {
    const res: IBaseResponeModel = yield call(dotDanhGiaApi.SelectByTruong, action.payload as IDotDanhGiaSelectRequest)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: IDotDanhGiaActions): any {
    let res: IBaseResponeModel;
    const payload = action.payload as IDotDanhGia;
    if (payload.id > 0) {
        res = yield call(dotDanhGiaApi.Update, payload)
    } else {
        res = yield call(dotDanhGiaApi.Insert, payload)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: IDotDanhGiaActions): any {
    const res: IBaseResponeModel = yield call(dotDanhGiaApi.Delete, action.payload as number)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}
